<template>
  <div class="mediaRecommendationDetail">
    <!-- 标题栏 -->
    <!-- <van-nav-bar :title="goodsChildName" left-arrow @click-left="onClickLeft" /> -->
    
    <!-- <div @click="toPublish" class="cover-fb" >授权成功{{ signInfo }}</div> -->
  </div>
</template>
<script src="https://lf3-static.bytednsdoc.com/obj/eden-cn/fljpeh7hozbf/douyin_open/cdn/dy_open_util_v0.0.6.umd.js"></script>
<script src="https://unpkg.byted-static.com/bridge/douyin_open/1.0.10/lib/douyin_open.umd.js"></script>

<script>
import TimUiMedia from '@/components/TimUiMedia'
import html2canvas from 'html2canvas'
import QRCode from 'qrcode'
import React, { useState, useEffect, useCallback } from 'react';
import { getConfigParams } from '../../server';
// import { getConfigParams } from '../../server';
// const { location } = window;
// const url = location.href;

// const timestamp = String(parseInt(Date.now() / 1000)); // 生成签名用的时间戳
// const nonce_str = 'Wm3WZYTPz0wzccnW'; // 生成签名用的随机字符串
// const jsb = ''; // 自定义测试用JSB方法名
// const params = {}; // 自定义测试用JSB方法参数
// const [sdk, setSdk] = useState("");
// const [ready, setReady] = useState(false);
// const [resultMsg, setResultMsg] = useState('');
// const [client_key, setClientKey] = useState('');
export default {
  name: 'empowerOwm',
  components: {
    TimUiMedia
  },
  data () {
    return {
      requestHeadUrl: 'https://owm.kequbang.com',
      // requestHeadUrl: 'http://localhost:8280',
      // requestHeadUrl: 'http://192.168.1.25:8280',
      requestHeadUrl2: 'http://192.168.1.25:8280',
      current: 1,
      showModal: false,
      list: [],
      nowInfo:{},
      signInfo: []
    }
  },
  created () {
    const thisObj = this
    let params = thisObj.$route.query
    thisObj.userId =params.state
    if (params.code) {
      var scopes = params.scopes
      var sc = scopes.split(",")
      var qx = false
      for (const i in sc) {
        if (sc[i] == 'basic_bc') {
          qx = true
        }
      }
      if (qx) {
        thisObj.dyCode =params.code
        thisObj.setTokenInfo()
      } else {
        thisObj.$util.showSuccessMsg("授权失败");
      }
    } else if (params.state) {
      thisObj.onLoad()
    }
    // alert(thisObj.userId+"::::::::::" + params.code)
  },
  watch: {
  },
  destroyed () {
      if(this.personFootInfo!=null){
        this.leavePersonFoot()
      }
  },
  mounted () {
    const thisObj = this

  },
  methods: {
    onLoad: function () {
      const thisObj = this

    // // 使用JSB能力前，必须先通过Config验证签名
    //   const config = useCallback(async () => {
    //       const { client_key, signature } = await getConfigParams({ timestamp, nonce_str, url });
    //       sdk.config({
    //         params: {
    //           client_key,
    //           signature,
    //           timestamp,
    //           nonce_str,
    //           url
    //         }
    //       });
    //       setClientKey(client_key);
    //     }, [sdk]);

    //   // 打开原生授权页面JSB能力示例
    //   const onClickAuth = () => {
    //       if (ready) {
    //         sdk.showOpenAuth({
    //           params: {
    //             client_key,
    //             state: '',
    //             scopes: {
    //               user_info: 0, // 0: 必选；1: 可选，默认不选中； 2: 可选，默认选中
    //             },          
    //             response_type: 'code'
    //           },
    //           success: ({ ticket }) => setResultMsg(`Auth Success: ${ticket}`),
    //           error: res => setResultMsg(`Auth Error: ${JSON.stringify(res)}`)
    //         });
    //       }
    //     };
    const sdk = window.DouyinOpenJSBridge;
    // alert(JSON.stringify(sdk))
    // sdk.config({
    //       params: {
    //         client_key: 'aw167hj16o0xd6k1', // clientKey在你的网页应用申请通过后得到
    //         signature: data.signature, // 服务端计算的签名，该签名被抖音开放平台验证通过后方可调用jsb方法
    //         timestamp: data.timestamp, // 时间戳
    //         nonce_str: data.nonceStr,
    //         url:"https://zxy.kqbang.cn", // 为应用申请的 JSB 安全域名下的链接，需要携带协议。e.g. https://jsb.security.domain/page.html
    //       },
          
    //     });
    //     sdk.ready(() => {
    //       alert("111")// Config Ready回调
    //     });
    //     sdk.error((res) => {
    //       alert("222"+res)// Config error回调
    //     });
      const url = location.href;
      // const timestamp = String(parseInt(Date.now() / 1000)); // 生成签名用的时间戳
      // const nonce_str = 'Wm3WZYTPz0wzccnW'; // 生成签名用的随机字符串
      // const { client_key, signature } = getConfigParams({ timestamp, nonce_str, url });
      // console.log(timestamp)
      // console.log(client_key)
      // console.log(signature)
      // sdk.config({
      //   params: {
      //     client_key,
      //     signature,
      //     timestamp,
      //     nonce_str,
      //     url
      //   }
      // });
      //   sdk.ready(() => {
      //     alert("111")// Config Ready回调
      //   });
      //   sdk.error((res) => {
      //     alert("222"+JSON.stringify(res))// Config error回调
      //   });
        
      thisObj.$api.get(thisObj.requestHeadUrl + '/dyUser/getAllSignInfo?url=' + url, {}).then(res => {
        var data = res.data
        thisObj.signInfo = data
        console.log(sdk)
        sdk.config({
          params: {
            client_key: 'aw167hj16o0xd6k1', // clientKey在你的网页应用申请通过后得到
            signature: data.signature, // 服务端计算的签名，该签名被抖音开放平台验证通过后方可调用jsb方法
            timestamp: data.timestamp, // 时间戳
            nonce_str: data.nonceStr,
            url:url, // 为应用申请的 JSB 安全域名下的链接，需要携带协议。e.g. https://jsb.security.domain/page.html
          },
          
        });
        
        sdk.ready(() => {
          
        });
        sdk.error((res) => {
          alert(JSON.stringify(res))// Config error回调
        });
          sdk.showOpenAuth({
            params: {
              client_key:'aw167hj16o0xd6k1',
              state: '',
              scopes: {
                user_info: 0, // 0: 必选；1: 可选，默认不选中； 2: 可选，默认选中
              },          
              response_type: 'code'
            },
            success: ({ ticket, grant_permissions }) => {
              // ticket： Oauth 凭据，详见下方说明
              // alert(ticket)
              thisObj.$api.get(thisObj.requestHeadUrl + '/dyUser/setSignInfo?userId=' + thisObj.userId + '&code=' + ticket, {}).then(res => {
                thisObj.$util.showSuccessMsg("用户绑定成功");
                // location.href = "https://open.douyin.com/platform/oauth/connect/?client_key=aw167hj16o0xd6k1&"+
                // "response_type=code&scope=video.create.bind&redirect_uri=https://zxy.kqbang.cn/empower"
              }).catch(function (error) {
              })
              // alert(grant_permissions)
              // grant_permissions： String 类型，用户授权的所有 scope，以“,”拼接，例：user_info,mobile
            },
            error: function (res) {
              // alert("22")
              alert(JSON.stringify(res))
            },
          });
          // sdk.showOpenAuth({
          //   params: {
          //     client_key:'aw167hj16o0xd6k1',
          //     state: '',
          //     scope: {
          //       user_info: 0,
          //       'video.create.bind':2, // 0: 必选；1: 可选，默认不选中； 2: 可选，默认选中
          //     },          
          //     response_type: 'code'
          //   },
          //   success: ({ ticket, grant_permissions }) => {
          //     // ticket： Oauth 凭据，详见下方说明
          //     // alert(ticket)
          //     thisObj.$api.get(thisObj.requestHeadUrl + '/dyUser/setSignInfo?userId=' + thisObj.userId + '&code=' + ticket, {}).then(res => {
          //       thisObj.$util.showSuccessMsg("用户绑定成功");
          //       // location.href = "https://open.douyin.com/platform/oauth/connect/?client_key=aw167hj16o0xd6k1&"+
          //       // "response_type=code&scope=video.create.bind&redirect_uri=https://zxy.kqbang.cn/empower"
          //     }).catch(function (error) {
          //     })
          //     // alert(grant_permissions)
          //     // grant_permissions： String 类型，用户授权的所有 scope，以“,”拼接，例：user_info,mobile
          //   },
          //   error: function (res) {
          //     // alert("22")
          //     alert(JSON.stringify(res))
          //   },
          // });
      }).catch(function (error) {
      })
      

      // var rr = window.location.href.split('?')
      // console.log(rr[rr.length-1])
      // // alert(rr[rr.length-1])
      // var ciphertext = rr[rr.length-1]
      // thisObj.$api.get(thisObj.requestHeadUrl + '/api/clip/get_clip_video?id='+ciphertext, {}).then(res => {
      //   // console.log(res)
      //     thisObj.list = res.data
      //     thisObj.nowInfo = res.data[0]
      // }).catch(function (error) {
      // })
      
    },

    setTokenInfo: function () {
      const thisObj = this
      thisObj.$api.get(thisObj.requestHeadUrl + '/dyUser/setTokenInfo?code=' + thisObj.dyCode+'&userId=' + thisObj.userId, {}).then(res => {
        if (res) {
          thisObj.$util.showSuccessMsg("授权成功");
        }
      }).catch(function (error) {
      })
    },

    toPublish () {
      // script 引入
      var thisObj = this
      thisObj.$api.get(thisObj.requestHeadUrl + '/celebrity/getSignInfo', {}).then(res => {
        console.log(res.data)
          var data = res.data
          const url = new URL("snssdk1128://openplatform/share");
          var query = url.searchParams;
          query.append("client_key", 'aw167hj16o0xd6k1');
          // query.append("state", share_id);
          query.append("nonce_str", data.nonceStr);
          query.append("timestamp", data.timestamp);
          query.append("signature", data.signature);
          query.append("share_type", "h5");
          // query.append(
          //   "image_path",
          //   "https://sf3-cdn-tos.douyinstatic.com/obj/douyin-open-static/tiktok.open/home/d_logo.png"
          // );
          // query.append("share_to_publish", "0");
          query.append("video_path", thisObj.nowInfo.videoUrl);
          // const hashTags = ["hashtag1", "hashtag2", "hashtag3", "天气不错"];
          // query.append("hashtag_list", JSON.stringify(hashTags));
          query.append("hashtag_list", thisObj.nowInfo.topic);
          query.append("poi_id", thisObj.nowInfo.poiId);
          // query.append(
          //   "micro_app_info",
          //   JSON.stringify({
          //     appId: "小程序appid",
          //     appTitle: "小程序title",
          //     description: "小程序描述语",
          //     appUrl: "pages/movie/index",
          //   })
          // );
          console.log(url)
          location.href = url
      }).catch(function (error) {
      })
      
    },
    // 目录/简介 tab切换
    switchTab (e) {
      let current = e.currentTarget.dataset.current
      this.current = current
    },
    // 生成图片
    toImg () {
      //   setTimeout(function () {
      // that.toImg()
      html2canvas(document.querySelector('#captureId')).then(canvas => {
        let imgUrl = canvas.toDataURL('image/png')
        let that = this
        that.dataURL = imgUrl
        // eslint-disable-next-line handle-callback-err
      }).catch(error => {
      })
      //   }, 500)
      this.showLoading = false
    },
    
  }
}
</script>
<style scoped>
.TimUi-audio-control {
  z-index: 20;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  align-items: center;
  height: 90px;
  padding: 0 35px;
  background: rgba(0, 0, 0, 0.6);
}
.TimUi-audio-control .TimUi-media {
  visibility: hidden;
}
.TimUi-audio-control .iconfont.fs-24 {
  margin: 0 4% 0 0;
  font-size: 24px;
  color: #fff;
}
.TimUi-audio-control .progress-bar {
  width: 100%;
  color: #fff;
}
.TimUi-audio-control .progress-bar .progress-slider {
  width: 92%;
  margin: 0 4%;
  padding: 12px 0 0 0;
}
.TimUi-audio-control .progress-bar .van-slider {
  width: 100%;
}
.cover-fb {
  font-size: 40px;
  position: fixed;
  bottom: 0;
  width: 100%;
  background-color: rgb(230, 39, 90);
  color: #fff;
  text-align: center;
  padding: 20px;
  border-radius: 30px;
}
</style>
